<template>
  <div class="adyen">
    <Back/>
    <AmountDisplayer/>
    <div class="adyen-wrapper">
      <div id="dropin-container" ref="dropinContainer"></div>
    </div>
  </div>
</template>
<script>
import { applyPay, getAdyenConfig, adyenAction, deleteAdyenCard } from '@/api'
import {
  saCreditCardSave,
  saCreditNewPayType,
  saCreditOriginPayType,
  saCreditCardPageViewed,
  saCreditCardPayClick,
  saCreditCarRemove
} from '@/utils/sa-methods'
import AdyenCheckout from '@adyen/adyen-web'
import '@adyen/adyen-web/dist/adyen.css'
import qs from 'qs'
import { adyenScreen } from '@/utils/screen'
import { postMessage } from '@hll/cashier-kit'
// const OK_CODE = 'Authorised'
export default {
  name: 'Adyen',
  props: {
    payToken: {
      type: String,
      default: ''
    },
    payChannelID: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      checkout: null
    }
  },
  created () {
    adyenScreen()
    postMessage({ action: 'processing', status: 1 })
  },
  mounted () {
    saCreditCardPageViewed()
    this.init()
  },
  methods: {
    init () {
      getAdyenConfig({ payToken: this.payToken, pay_channel_id: this.payChannelID, remember: 1 }).then(res => {
        const {
          payment: paymentMethodsResponse,
          environment,
          originKey: clientKey,
          shopperReference,
          locale = 'en_US'
        } = res
        const configuration = {
          locale,
          environment,
          clientKey,
          paymentMethodsResponse, // The payment methods response returned in step 1.
          onSubmit: this.handleOnSubmit, // Your function for handling onChange event
          onAdditionalDetails: this.handleOnAdditionalDetails,
          shopperReference,
          showRemovePaymentMethodButton: true,
          onDisableStoredPaymentMethod: this.onDisableStoredPaymentMethod,
          socialSecurityNumberMode: 'show',
          paymentMethodsConfiguration: {
            card: { // Example optional configuration for Cards
              hasHolderName: true,
              holderNameRequired: true,
              enableStoreDetails: true,
              showStoredPaymentMethods: true,
              socialSecurityNumberMode: 'show'
            }
          }
        }
        this.checkout = new AdyenCheckout(configuration)
        this.checkout.create('dropin').mount(this.$refs.dropinContainer)
        saCreditOriginPayType(paymentMethodsResponse.storedPaymentMethods ? 'saved_credit_card' : 'new_credit_card')
      })
    },
    handleOnSubmit (state, dropin) {
      const { paymentMethod, storePaymentMethod, browserInfo } = state.data
      const params = {
        payToken: this.payToken,
        pay_channel_id: this.payChannelID,
        paymentMethod,
        remember: storePaymentMethod ? '1' : '',
        card: JSON.stringify({
          browserInfo,
          origin: window.location.origin,
          deviceFingerPrinting: document.querySelector('#deviceFingerPrinting')?.value
        }),
        return_url_params: qs.stringify({ component: 'Result', type: 'unknown', payToken: this.payToken })
      }
      applyPay(params).then(res => {
        const { action } = res.payInfo
        if (action) {
          // Drop-in handles the action object from the /payments response
          dropin.handleAction(action)
        } else {
          // Your function to show the final result to the shopper
          this.$emit('goTo', { component: 'Result', type: 'unknown' })
        }
        // if (resultCode === OK_CODE) { this.$emit('goTo', { component: 'Result', type: 'unknown' }) }
        // else if (action) {
        //   this.checkout.createFromAction(action).mount('#addtional-container')
        // } else {
        //   this.$hll.toast({
        //     message: refusalReason,
        //     iconClass: 'icon-warning'
        //   })
        // }
      })
      saCreditCardSave(storePaymentMethod ? 'ticked' : 'unticked')
      saCreditNewPayType(paymentMethod.storedPaymentMethods ? 'saved_credit_card' : 'new_credit_card')
      saCreditCardPayClick(paymentMethod.storedPaymentMethods ? 'saved_credit_card' : 'new_credit_card')
    },
    handleOnAdditionalDetails (state, dropin) {
      const params = {
        payToken: this.payToken,
        pay_channel_id: this.payChannelID,
        action: state.data
      }
      adyenAction(params).then(res => {
        const { action } = res

        if (action) {
          // Drop-in handles the action object from the /payments response
          dropin.handleAction(action)
        } else {
          // Your function to show the final result to the shopper
          this.$emit('goTo', { component: 'Result', type: 'unknown' })
        }
      }
      )
    },
    onDisableStoredPaymentMethod (options, resolve, reject) {
      const recurringDetailReference = options.data.paymentMethod.storedPaymentMethodId
      deleteAdyenCard({
        recurringDetailReference,
        payToken: this.payToken,
        pay_channel_id: this.payChannelID
      }).then(res => {
        resolve(res.res_data)
      }, res => {
        reject(res)
      }).catch(e => {
        reject(e)
      })
      saCreditCarRemove()
    }
  }
}
</script>

<style lang="scss">
.adyen {
  padding: 48px 40px;

  .adyen-checkout__button--pay {
    background-color: #F16622;
  }

  .adyen-checkout__payment-method__radio--selected {
    background: #F16622;

    &:hover {
      box-shadow: 0 0 0 2px #F16622
    }
  }

  .adyen-checkout__checkbox__input:checked + .adyen-checkout__checkbox__label:after {
    border: #F16622;
    background: #F16622;
  }

  .adyen-checkout__spinner {
    border-radius: 50%;
    height: 43px;
    width: 43px;
    border: 3px solid #F16622;
    border-top-color: transparent;
    -webkit-animation: rotateSpinner 1.5s linear infinite;
    animation: rotateSpinner 1.5s linear infinite;
  }

  .adyen-wrapper {
    padding: 10px;
  }
}
</style>
